<template>
  <span v-if="content">{{ content }}</span>
  <span v-else>{{ fallback }}</span>
</template>

<script lang="ts">
import BANNER_CONTENT_QUERY from '../../graphql/contentful/queries';

export default {
  name: 'ContentfulText',
  props: {
    contentType: { type: String, required: true },
    fieldName: { type: String, required: true },
    fallback: { type: String, required: true },
  },
  data() {
    return {
      content: '',
      loading: true,
    };
  },
  apollo: {
    bannerContent: {
      query: BANNER_CONTENT_QUERY,
      variables() {
        return {
          contentType: this.contentType,
          fieldName: this.fieldName,
        };
      },
      result({ data }) {
        this.content = (data && data.bannerContent) || this.fallback;
      },
      error() {
        console.warn('Contentful API error, using fallback content');
        this.content = this.fallback;
      },
    },
  },
};
</script>
